<template>
  <div>
    <v-skeleton-loader v-if="loading" type="card" />
    <template v-else>
      <!-- Assigned state -->
      <v-card v-if="isAssigned" outlined class="facility-zone-card">
        <v-toolbar dense color="grey lighten-2">
          <v-toolbar-title class="subtitle-1">Facility Zone</v-toolbar-title>
          <v-spacer />
          <v-btn outlined small @click="showUpdateZoneDialog = true">
            <v-icon small left>fas fa-edit</v-icon>
            Update Zone
          </v-btn>
        </v-toolbar>
        <v-divider />

        <v-card-text>
          <dl class="property-list">
            <dt>Zone Name</dt>
            <dd>{{ unit.parent.name }}</dd>

            <dt>Units In Zone</dt>
            <dd>
              <span v-if="zoneUnitsLoading">
                <v-progress-circular
                  indeterminate
                  size="12"
                  width="2"
                  color="grey"
                />
              </span>
              <span v-else>{{ zoneUnitCount }} units</span>
            </dd>
          </dl>

          <v-btn
            outlined
            small
            class="mt-3"
            :to="{
              name: 'ViewSmartZone',
              params: { smart_zone_id: unit.parent.id },
            }"
          >
            <v-icon small left>mdi-eye</v-icon>
            View Zone Details
          </v-btn>
        </v-card-text>
      </v-card>

      <!-- Unassigned state -->
      <v-card
        v-else
        outlined
        class="facility-zone-card facility-zone-unassigned"
      >
        <v-toolbar dense color="grey lighten-2">
          <v-toolbar-title class="subtitle-1">Facility Zone</v-toolbar-title>
          <v-spacer />
          <v-btn outlined small @click="showUpdateZoneDialog = true">
            <v-icon small left>fas fa-edit</v-icon>
            Assign Zone
          </v-btn>
        </v-toolbar>
        <v-divider />

        <v-card-text>
          <dl class="property-list">
            <dt>Zone Name</dt>
            <dd>Unassigned</dd>

            <dt>Units In Zone</dt>
            <dd>—</dd>
          </dl>

          <!-- <v-btn
          color="primary"
          small
          class="mt-3"
          @click="showUpdateZoneDialog = true"
        >
          <v-icon small left>mdi-plus</v-icon>
          Assign Zone
        </v-btn> -->
        </v-card-text>
      </v-card>

      <DialogUpdateZone
        v-if="showUpdateZoneDialog"
        :unit-id="unit.id"
        :unit-name="unit.name"
        :facility-id="facilityId"
        :current-zone-id="isAssigned ? unit.parent.id : null"
        @saved="handleZoneSaved"
        @close="showUpdateZoneDialog = false"
      />
    </template>
  </div>
</template>

<script>
import DialogUpdateZone from "../common/DialogUpdateZone.vue";
import { GET_ZONE_UNITS } from "@components/smart_zones/graphql";

export default {
  name: "CardFacilityZone",
  components: {
    DialogUpdateZone,
  },
  props: {
    unit: {
      type: Object,
      required: true,
    },
    facilityId: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showUpdateZoneDialog: false,
      zoneUnits: [],
    };
  },
  computed: {
    isAssigned() {
      return this.unit?.parent?.subtype === "zone";
    },
    zoneId() {
      return this.isAssigned ? this.unit.parent.id : null;
    },
    zoneUnitsLoading() {
      return this.$apollo.queries.zoneUnits?.loading;
    },
    zoneUnitCount() {
      return this.zoneUnits.length;
    },
  },
  apollo: {
    zoneUnits: {
      query: GET_ZONE_UNITS,
      variables() {
        return { zoneId: this.zoneId };
      },
      update({ organizationDescendants }) {
        return organizationDescendants || [];
      },
      skip() {
        return !this.zoneId;
      },
    },
  },
  methods: {
    handleZoneSaved() {
      this.showUpdateZoneDialog = false;
      this.$emit("zone-updated");
    },
  },
};
</script>

<style scoped>
/* Neutral card styling to match the sibling info cards (e.g. Smart Unit
   Information): white body, subtle grey border, grey header bar. Applies to
   both the assigned and unassigned states. */
.facility-zone-card,
.facility-zone-unassigned {
  background: #fff !important;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
